var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59804 0.000106927C1.88643 -0.00234333 2.16497 0.104892 2.37726 0.300097L5.75215 3.48524L9.12105 0.303847C9.33307 0.108466 9.61083 0 9.89915 0C10.1875 0 10.4652 0.108466 10.6772 0.303847C10.779 0.397413 10.8602 0.51108 10.9158 0.637656C10.9714 0.764232 11.0001 0.900963 11.0001 1.0392C11.0001 1.17743 10.9714 1.31416 10.9158 1.44074C10.8602 1.56732 10.779 1.68098 10.6772 1.77455L6.52613 5.69467C6.31485 5.89093 6.03715 6 5.74878 6C5.46041 6 5.18271 5.89093 4.97143 5.69467L0.821815 1.77455C0.719855 1.6811 0.638443 1.56748 0.582747 1.44088C0.527052 1.31429 0.498291 1.1775 0.498291 1.0392C0.498291 0.900895 0.527052 0.764104 0.582747 0.637511C0.638443 0.510919 0.719855 0.397292 0.821815 0.303847C1.03253 0.107598 1.31009 -0.00101322 1.59804 0.000106927Z",
    fill: "#4CB596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.f9484b9c72a358c9049e37ba37f67b6e.svg";
export { ForwardRef as ReactComponent };